import { jsx as _jsx } from "react/jsx-runtime";
import '@streamr/tv-ui/dist/tv-ui.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { initServices } from './services/initServices';
import { initRemoteLogger } from './utils/remoteLogger';
import { initSentry } from './utils/sentry';
initRemoteLogger();
initSentry();
async function bootstrap() {
    try {
        await initServices();
    }
    catch (error) {
        console.error('Error initializing services', error);
        return;
    }
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(App, {}));
    reportWebVitals();
}
// biome-ignore lint/nursery/noFloatingPromises: TODO
bootstrap();
